import exp from 'constants';
import React from 'react';
import { __ } from '../../../../helpers/TranslationService';
import { SearchResultItemOverlay } from '../SearchResultItemOverlay';
import {
    PackageLabelWrapper,
    PackageLabelText,
    PackageLabelIconStyled,
    PackageLabelButton,
    InfoTransparentIconStyled,
    StyledInfoModal,
} from './styles';
import {
    IExperience,
    IMobileSearchResultSail,
    IMobileSearchResultCruise,
} from '../../../../interfaces/ISearchApi';

interface IProps {
    iconProps: {
        width: number;
        height: number;
    };
    typeOfBadge?: string;
    selectedSail?: IMobileSearchResultSail;
    cruise: IMobileSearchResultCruise;
    packagesUrl?: string;
    isCruise1st?: boolean;
    isExperienceBadgeType?: boolean;
    packageInfo?: IExperience;
}

export const SearchResultItemBadge = ({
    isExperienceBadgeType,
    isCruise1st,
    iconProps,
    packageInfo,
    cruise,
    selectedSail,
    typeOfBadge,
    packagesUrl,
}: IProps) => {
    const [showModal, setShowModal] = React.useState(false);

    const handleOnClickBadge = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setShowModal(true);
    };

    return (
        <React.Fragment key={cruise.cruiseNid}>
            <PackageLabelWrapper
                onClick={handleOnClickBadge}
                isExperience={isExperienceBadgeType}
                isCruise1st={isCruise1st}
            >
                <PackageLabelText isExperience={isExperienceBadgeType} isCruise1st={isCruise1st}>
                    <PackageLabelIconStyled {...iconProps} />
                    {isExperienceBadgeType
                        ? packageInfo.title
                        : __('Dreamlines Package', 'dreamlines')}
                </PackageLabelText>
                <PackageLabelButton isExperience={isExperienceBadgeType} isCruise1st={isCruise1st}>
                    <InfoTransparentIconStyled width={12} height={12} {...iconProps} />
                </PackageLabelButton>
            </PackageLabelWrapper>
            {showModal && (
                <StyledInfoModal
                    isOpen
                    onClose={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowModal(false);
                    }}
                >
                    {isExperienceBadgeType ? (
                        <SearchResultItemOverlay
                            cruise={cruise}
                            packagesUrl={packagesUrl}
                            selectedSail={selectedSail}
                            typeOfBadge={typeOfBadge}
                            experienceTitle={packageInfo.title}
                            experienceDescription={packageInfo.description}
                            experienceUrl={packageInfo.url}
                        />
                    ) : (
                        <SearchResultItemOverlay
                            cruise={cruise}
                            typeOfBadge={typeOfBadge}
                            packagesUrl={packagesUrl}
                            selectedSail={selectedSail}
                        />
                    )}
                </StyledInfoModal>
            )}
        </React.Fragment>
    );
};
